import { createFileRoute } from "@tanstack/react-router";

import { ForgeAutomationCreatePage } from "../components/automations/ForgeAutomationCreatePage";

export const Route = createFileRoute("/_chat/automations/new")({
  component: ForgeAutomationCreatePage,
});
